import React from 'react';
import NavOptions from '../constants/NavOptions';
import { createStackNavigator } from '@react-navigation/stack';
import { useLinkTo } from '@react-navigation/native';

import ContractorsScreen from './Contractor/ContractorsScreen';
import ContractorScreen from './Contractor/ContractorScreen';
import InviteScreen from './Projects/Project/InviteScreen';
import InviteSuccess from './Projects/Project/InviteSuccess';

const Stack = createStackNavigator();

export default function ContractorsStack({ navigation }) {
  const linkTo = useLinkTo();

  React.useEffect(() => {
    const unsubscribe = navigation.addListener('tabPress', (e) => {
      console.log('tabPress');
      linkTo('/contractors');
    });

    return unsubscribe;
  }, [navigation]);

  return (
    <Stack.Navigator initialRouteName='Contractors' screenOptions={NavOptions.all}>
      <Stack.Screen name='Contractors' component={ContractorsScreen} />
      <Stack.Screen name='Contractor' component={ContractorScreen} />
      <Stack.Screen
        name='InviteScreen'
        component={InviteScreen}
        // options={{ headerShown: true, title: '' }}
        // initialParams={{ inviteType: 'Contractors' }}
      />
      <Stack.Screen
        name='InviteSuccess'
        component={InviteSuccess}
      />
    </Stack.Navigator>
  )

}